import React, { useEffect, useState } from "react";
import CartCount from "./CartCount";
import CartItems from "./CartItems";
import EmptyCart from "./EmptyCart";

const Cart = ({ showCart, setShowCart, cartItems, setCartItems }) => {
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    setTotalPrice(cartItems?.reduce((sum, val) => Number(val.price) + sum, 0));
  }, [cartItems]);



  return (
    <div
      onClick={() => setShowCart(!showCart)}
      className={`fixed top-0 right-0 left-0 bottom-0 opacity-[100] z-[250] blur-effect-theme w-full h-screen transition-all duration-700 ease-in ${
        showCart
          ? "opacity-100 z-[250] translate-x-0 visible"
          : " opacity-0 translate-x-12 invisible"
      } `}
    >
      <div className="blur-effect-theme h-screen max-w-xl absolute right-0 w-full">
        <CartCount
          showCart={showCart}
          setShowCart={setShowCart}
          cartItems={cartItems}
        />
        {cartItems?.length > 0 ? (
          <div className="flex flex-col justify-between pb-10 h-screen px-2">
            <div className="pb-6 overflow-y-scroll overflow-hidden ">
              {cartItems?.map((item, index) => (
                <CartItems
                  key={index}
                  item={item}
                  setCartItems={setCartItems}
                />
              ))}
            </div>
            <div className="px-2">
              <div className="flex items-center justify-between ">
                <h1 className="font-bold capitalize text-slate-800">
                  sub total
                </h1>
                <span className="font-bold capitalize text-slate-800">
                  ${totalPrice}
                </span>
              </div>
              <div className="text-center">
                Taxes and Shipping will caluclate at shipping.
              </div>
              <div className="text-center pt-2">
                <button className="button-theme  w-full bg-slate-900 text-slate-200 capitalize ">
                  check out
                </button>
              </div>
            </div>
          </div>
        ) : (
          <EmptyCart showCart={showCart} setShowCart={setShowCart} />
        )}
      </div>
    </div>
  );
};

export default Cart;
